import React, { Component } from 'react'
import { useSelector, useDispatch, connect } from 'react-redux'
import Carousel from 'react-bootstrap/Carousel';

import {
  CInputGroupText,
  CInputGroupAppend,
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,
  CFormGroup,
  CInputGroup,
  CInput,
  CButton,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CTooltip,
  CPopover,
  CLabel,
  CSelect,
  CFormText,
  CTextarea,
  CInputFile,
  CSwitch,
} from '@coreui/react'
import { createHashHistory } from 'history'
import HeaderSection from "../header/HeaderSection"
import FooterSection from '../Footer/FooterSection'
import DoctorSidebar from './DoctorSidebar';
import { Link } from 'react-router-dom'

const history = createHashHistory()
const DoctorInvoices = (props) => {
    return (
        <div>
          {/* doccure/invoices.html  30 Nov 2019 04:12:14 GMT */}
          <meta charSet="utf-8" />
          <title>Medisevas</title>
          <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />
          {/* Favicons */}
          <link href="assets/img/favicon.png" rel="icon" />
          {/* Bootstrap CSS */}
          <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
          {/* Fontawesome CSS */}
          <link rel="stylesheet" href="assets/plugins/fontawesome/css/fontawesome.min.css" />
          <link rel="stylesheet" href="assets/plugins/fontawesome/css/all.min.css" />
          {/* Main CSS */}
          <link rel="stylesheet" href="assets/css/style.css" />
          {/* HTML5 shim and Respond.js IE8 support of HTML5 elements and media queries */}
          {/*[if lt IE 9]>
              
              
          <![endif]*/}
          {/* Main Wrapper */}
          <div >
                    <div className="card card-table">
                      <div className="card-body">
                        {/* Invoice Table */}
                        <div className="table-responsive">
                          <table className="table table-hover table-center mb-0">
                            <thead>
                              <tr>
                                <th>Invoice No</th>
                                <th>Patient</th>
                                <th>Amount</th>
                                <th>Paid On</th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0010</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Richard Wilson <span>#PT0016</span></Link>
                                  </h2>
                                </td>
                                <td>$450</td>
                                <td>14 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0009</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient1.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Charlene Reed <span>#PT0001</span></Link>
                                  </h2>
                                </td>
                                <td>$200</td>
                                <td>13 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0008</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient2.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Travis Trimble <span>#PT0002</span></Link>
                                  </h2>
                                </td>
                                <td>$100</td>
                                <td>12 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0007</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient3.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Carl Kelly <span>#PT0003</span></Link>
                                  </h2>
                                </td>
                                <td>$350</td>
                                <td>11 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0006</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient4.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Michelle Fairfax <span>#PT0004</span></Link>
                                  </h2>
                                </td>
                                <td>$275</td>
                                <td>10 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0005</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient5.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Gina Moore <span>#PT0005</span></Link>
                                  </h2>
                                </td>
                                <td>$600</td>
                                <td>9 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0004</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient6.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Elsie Gilley <span>#PT0006</span></Link>
                                  </h2>
                                </td>
                                <td>$50</td>
                                <td>8 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0003</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient7.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Joan Gardner <span>#PT0007</span></Link>
                                  </h2>
                                </td>
                                <td>$400</td>
                                <td>7 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0002</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient8.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Daniel Griffing <span>#PT0008</span></Link>
                                  </h2>
                                </td>
                                <td>$550</td>
                                <td>6 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a href="invoice-view.html">#INV-0001</a>
                                </td>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to="/doctor/PatientProfile" className="avatar avatar-sm mr-2">
                                      <img className="avatar-img rounded-circle" src="assets/img/patients/patient9.jpg" alt="User Image" />
                                    </Link>
                                    <Link to="/doctor/PatientProfile">Walter Roberson <span>#PT0009</span></Link>
                                  </h2>
                                </td>
                                <td>$100</td>
                                <td>5 Nov 2019</td>
                                <td className="text-right">
                                  <div className="table-action">
                                    <a href="invoice-view.html" className="btn btn-sm bg-info-light">
                                      <i className="far fa-eye" /> View
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                      <i className="fas fa-print" /> Print
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* /Invoice Table */}
                      </div>
                    </div>
                  </div>
          {/* /Main Wrapper */}
          {/* jQuery */}
          {/* Bootstrap Core JS */}
          {/* Sticky Sidebar JS */}
          {/* Custom JS */}
          {/* doccure/invoices.html  30 Nov 2019 04:12:14 GMT */}
        </div>
      );
    };

// export default TheHeaderDropdown
const mapStateToProps = (state) => ({
})
export default connect(mapStateToProps, {
})(DoctorInvoices)